import React, { FC, useContext } from 'react';

import { Separator, Toggle } from '@smartshell/ui-kit';

import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

import s from '../OnlineBooking/OnlineBooking.module.scss';

export const Workload: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('booking');

  const {
    state: {
      settings: {
        onlineBooking,
        onlineBookingBusy,
        onlineBookingPerMinuteEndingEnabled,
      },
    },
    actions: { setSetting },
  } = useContext(SettingsContext);
  return (
    <div className={s.settings}>
      <Toggle
        label={t('setting.onlineBooking.realBusy')}
        description={t('settings.smartGamer.booking.workload.description')}
        value={onlineBookingBusy}
        onChange={(value: boolean) =>
          setSetting({
            alias: ESettingsAliases.ONLINE_BOOKING_BUSY,
            value: value ? '1' : '0',
          })
        }
        variant="secondary"
        emptyBg
        disabled={!onlineBooking || !isAvailable}
      />
      <Separator />
      <Toggle
        label={t('setting.onlineBooking.per_minute_ending')}
        value={onlineBookingPerMinuteEndingEnabled}
        description={t('settings.smartGamer.booking.take_into.description')}
        className={s.multipleHost}
        onChange={(value: boolean) =>
          setSetting({
            alias: ESettingsAliases.ONLINE_BOOKING_PER_MINUTE_ENDING,
            value: value ? '1' : '0',
          })
        }
        variant="secondary"
        emptyBg
        disabled={!onlineBooking || !isAvailable}
      />
    </div>
  );
};
